<template>
  <div class='animated fadeIn'>
    <b-row class='justify-content-md-center'>
      <b-col cols='12' lg='10'>
        <b-card class='shadow-sm bg-white rounded' border-variant='light' header-bg-variant='secondary'>
          <b-list-group flush>
            <b-list-group-item>
                <b-row class='justify-content-md-center'>
                  <b-col sm='2'>
                    <b-row>
                      <b-img v-if='user && user.icon' :src='user.icon' width='128' height='128' rounded></b-img>
                      <i v-else class='fas fa-user-circle fa-3x'></i>
                    </b-row>
                  </b-col>
                  <b-col sm='7'>
                    <croppa v-if='provider == false'
                      v-model='myCroppa'
                      :width='256'
                      :height='256'
                      :auto-sizing='true'
                      placeholder='プロフィール画像選択'
                      :placeholder-font-size='14'
                      :accept="'image/*'"></croppa>
                  </b-col>
                  <b-col sm='2'>
                    <b-button v-if='user.key' class='submit-btn' variant='danger' v-b-modal.modal-center>更新</b-button>
                    <b-button v-else class='submit-btn' variant='danger' v-b-modal.modal-center>登録</b-button>
                    <b-modal v-if='user.key' id='modal-center'
                            ref='modal'
                            title='プロフィール'
                            @ok='storeData'
                            centered
                            header-bg-variant='danger'
                            body-text-variant='danger'
                            ok-variant='danger'
                            size='sm'
                            class='px100-btn'
                          >
                      <p class='my-4'>プロフィール情報を更新します</p>
                      <p class='my-4'>よろしいですか?</p>
                    </b-modal>
                    <b-modal v-else id='modal-center'
                            ref='modal'
                            title='プロフィール'
                            @ok='storeData'
                            centered
                            header-bg-variant='danger'
                            body-text-variant='danger'
                            ok-variant='danger'
                            size='sm'
                            class='px100-btn'
                          >
                      <p class='my-4'>プロフィール情報を登録します</p>
                      <p class='my-4'>よろしいですか?</p>
                    </b-modal>
                  </b-col>
                </b-row>
            </b-list-group-item>

            <b-list-group-item>
              <b-row>
                <b-col sm='3'><label for='input-none'>{{getTitle('name')}}:</label></b-col>
                <b-col sm='9'><el-input size="medium" type='text' v-model='user.name' :disabled='provider'></el-input></b-col>
              </b-row>
              <b-row>
                <b-col sm='3'><label for='input-none'>{{getTitle('status')}}:</label></b-col>
                <b-col sm='9'><el-input size="medium" type='text' v-model='user.status'></el-input></b-col>
              </b-row>
              <b-row>
                <b-col sm='3'><label for='input-none'>{{getTitle('email')}}:</label></b-col>
                <b-col sm='9'><el-input size="medium" type='text' v-model='user.email' disabled></el-input></b-col>
              </b-row>
              <b-row>
                <b-col sm='3'><label for='input-none'>{{getTitle('role')}}:</label></b-col>
                <b-col sm='9'><el-input size="medium" type='text' v-model='user.role' disabled></el-input></b-col>
              </b-row>
              <b-row>
                <b-col sm='3'><label for='input-none'>{{getTitle('option')}}:</label></b-col>
                <b-col sm='9'>
                  <b-list-group flush>
                    <b-list-group-item>姓 (漢字)
                      <el-input size='medium' type='text' v-model="user.option['name']['first']"></el-input>
                    </b-list-group-item>
                    <b-list-group-item>姓 (カナ)
                      <el-input size='medium' type='text' v-model="user.option['name']['first_kana']"></el-input>
                    </b-list-group-item>
                    <b-list-group-item>名 (漢字)
                      <el-input size='medium' type='text' v-model="user.option['name']['last']"></el-input>
                    </b-list-group-item>
                    <b-list-group-item>名 (カナ)
                      <el-input size='medium' type='text' v-model="user.option['name']['last_kana']"></el-input>
                    </b-list-group-item>

                    <b-list-group-item>生年月日
                          <div class='block'>
                            <el-date-picker
                              v-model="user.option['dateOfBirth']['text']"
                              type='date'
                              placeholder='Pick a day'
                              @change='dateInput()'
                              value-format='yyyy/MM/dd'>
                            </el-date-picker>
                          </div>
                    </b-list-group-item>
                    <b-list-group-item>団体名
                      <el-input size='medium' type='text' v-model="user.option['organization']['company']"></el-input>
                    </b-list-group-item>
                    <b-list-group-item>部署名
                      <el-input size='medium' type='text' v-model="user.option['organization']['department']"></el-input>
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item>
              <b-row>
                <b-col sm='4'><label for='input-none'>{{getTitle('services')}}:</label></b-col>
                <b-col sm='2'></b-col>
              </b-row>
              <b-row>
                <b-col sm='2'></b-col>
                <b-col sm='10'>
                  <b-table
                    :items='myService'
                    :fields='fields'>
                    <div slot='icon' class='avatar' slot-scope='item'>
                      <b-img v-if='item.value' :src='item.value' width='32' height='32'></b-img>
                      <!-- <b-img v-else src='../admin.png' width='32' height='32' class='img-avatar'></b-img> -->
                    </div>
                    <div slot='name' slot-scope='item'>
                      <p>{{ item.value }}</p>
                    </div>
                  </b-table>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item>
              <b-row>
                <b-col sm='4'><label for='input-none'>{{getTitle('groups')}}:</label></b-col>
                <b-col sm='2'></b-col>
              </b-row>
              <b-row>
                <b-col sm='2'></b-col>
                <b-col sm='10'>
                  <b-table
                    :items='myGroup'
                    :fields='fields'>
                    <div slot='icon' class='avatar' slot-scope='item'>
                      <b-img v-if='item.value' :src='item.value' width='32' height='32'></b-img>
                      <!-- <b-img v-else src='../admin.png' width='32' height='32' class='img-avatar'></b-img> -->
                    </div>
                    <div slot='name' slot-scope='item'>
                      <p>{{ item.value }}</p>
                    </div>
                  </b-table>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item>
              <b-row>
                <b-col sm='4'><label for='input-none'>{{getTitle('updatedAt')}}:</label></b-col>
                <b-col>{{ user.updatedAt * 1000 | moment }}</b-col>
              </b-row>
              <b-row>
                <b-col sm='4'><label for='input-none'>{{getTitle('createdAt')}}:</label></b-col>
                <b-col>{{ user.createdAt * 1000 | moment }}</b-col>
              </b-row>
            </b-list-group-item>
          </b-list-group>
        </b-card>
        <b-modal ref='errorModal' centered title='Error' class='text-danger' :ok-only='true' ok-variant=danger header-bg-variant=danger>
          <p class='my-4'>{{errorMessage}}</p>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/storage'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  data: () => {
    return {
      fields: {
        icon: {
          label: '',
          class: 'text-center'
        },
        name: {
          label: '名称',
          class: 'text-center'
        }
      },
      myCroppa: {},
      errorMessage: '',
      file: null,
      uploadedImage: null,
      titles: {
        'owner': 'Created by',
        'role': '権限',
        'name': '名前',
        'email': 'Email',
        'services': '所属サービス',
        'groups': '所属グループ',
        'status': '私のスローガン',
        'icon': 'Icon',
        'routine': 'Routine',
        'enable': 'Enable',
        'option': '補足情報',
        'updatedAt': '更新日時',
        'createdAt': '作成日時'
      },
      user: null,
      provider: false,
      myService: [],
      myGroup: [],
      unwatch: null,
      dateOfBirth: ''
    }
  },
  beforeDestroy () {
    if (this.unwatch) {
      this.unwatch()
    }
  },
  created () {
    this.unwatch = this.$store.watch(state => this.$store.getters['authUser/user'], value => {
      if (value) {
        this.init()
      }
    })
    this.init()
  },
  methods: {
    init () {
      var vm = this
      this.user = JSON.parse(JSON.stringify(this.authUser))
      this.myService = []
      this.myGroup = []
      var keys = Object.keys(this.user.services)
      for (var i = 0; i < keys.length; i++) {
        if (this.user.services[keys[i]]) {
          const index = this.services.findIndex(service => service.key === keys[i])
          if (index !== -1) {
            var service = this.services[index]
            var payload = {
              'name': service.name,
              'icon': service.icon
            }
            this.myService.push(payload)
          }
        }
      }
      keys = Object.keys(this.user.groups)
      for (i = 0; i < keys.length; i++) {
        if (this.user.groups[keys[i]]) {
          const index = this.groups.findIndex(group => group.key === keys[i])
          if (index !== -1) {
            var group = this.groups[index]
            payload = {
              'name': group.name,
              'icon': group.icon
            }
            this.myGroup.push(payload)
          }
        }
      }
      if (!this.user.option['name']) {
        this.user.option = {
          'name': {
            'first': '',
            'first_kana': '',
            'last': '',
            'last_kana': ''
          },
          'dateOfBirth': {
            'int': parseInt(new Date().getTime() / 1000),
            'text': moment(new Date()).format('YYYY/MM/DD')
          },
          'organization': {
            'company': '',
            'department': ''
          }
        }
      }
      firebase.auth().currentUser.providerData.forEach(function (profile) {
        if (profile.providerId === 'google.com' || profile.providerId === 'facebook.com') {
          vm.provider = true
        }
      })
    },
    dateInput () {
      this.user.option['dateOfBirth']['int'] = parseInt(new Date(this.user.option['dateOfBirth']['text']).getTime() / 1000)
    },
    dateString (date) {
      var objDate = new Date(date)
      return moment(objDate).format('YYYY/MM/DD')
    },
    showModal () {
      this.$refs.errorModal.show()
    },
    hideModal () {
      this.$refs.errorModal.hide()
    },
    generateImage: function () {
      let url = this.myCroppa.generateDataUrl()
      if (!url) {
        this.errorMessage = 'No image selected'
        this.showModal()
      }
    },
    goBack () {
      this.$router.go(-1)
    },
    getTitle (item) {
      return this.titles[item]
    },
    onFileSelected (event) {
      this.file = event.target.files[0]
      this.createImage(this.file)
    },
    createImage (file) {
      let reader = new FileReader()
      reader.onload = (e) => {
        this.user.icon = e.target.result
      }
      reader.readAsDataURL(file)
    },
    writeuser () {
      var vm = this
      const payload = {
        'key': this.user.key,
        'role': this.user.role,
        'services': this.user.services,
        'groups': this.user.groups,
        'name': this.user.name,
        'email': this.user.email,
        'status': this.user.status,
        'icon': this.user.icon,
        'routine': this.user.routine,
        'enable': this.user.enable,
        'option': this.user.option,
        'createdAt': this.user.createdAt,
        'updatedAt': parseInt(new Date().getTime() / 1000)
      }
      const db = firebase.firestore()
      const settings = { timestampsInSnapshots: true }
      db.settings(settings)
      const batch = db.batch()
      var refuser = db.collection('users').doc(this.user.key)
      batch.set(refuser, payload)
      batch.commit().then(function () {
        vm.offLoading()
        // vm.$router.go(-1)
      })
    },
    storeData () {
      var vm = this
      vm.onLoading()
      if (!this.provider) {
        this.myCroppa.generateBlob((blob) => {
          if (blob) {
            var uuid = this.generateUuid()
            var storageRef = firebase.storage().ref().child('users').child(this.user.key).child(uuid)
            var uploadTask = storageRef.put(blob)
            uploadTask.on('state_changed', function (snapshot) {
              // var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
              switch (snapshot.state) {
                case firebase.storage.TaskState.PAUSED: // or 'paused'
                  break
                case firebase.storage.TaskState.RUNNING: // or 'running'
                  break
              }
            }, function (error) {
              vm.offLoading()
              vm.errorMessage = error.errorMessage
              vm.showModal()
            }, function () {
              uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                vm.user.icon = downloadURL
                vm.myCroppa.remove()
                vm.writeuser()
              })
            })
          } else {
            vm.writeuser()
          }
        })
      } else {
        vm.writeuser()
      }
    }
  },
  computed: {
    ...mapGetters({
      routines: 'routine/routines',
      routineGroups: 'routineGroup/routineGroups',
      routineRefs: 'routineRef/routineRefs',
      services: 'service/services',
      groups: 'group/groups',
      users: 'user/users',
      authUser: 'authUser/user',
      parameter: 'dispatch/user'
    })
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY/MM/DD HH:mm')
    },
    momentShort: function (date) {
      return moment(date).format('YYYY/MM/DD')
    },
    momentMMDD: function (date) {
      return moment(date).format('MM/DD')
    }
  }
}
</script>

<style>
.textTitle {
  white-space: normal;
}
.img {
  max-width: 100%;
  height: auto;
}
.row {
  padding-bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue